export default "__VITE_ASSET__XP8p_w6h__"